import { apiGet, toAbsoluteUrl } from "./client";

/** Отчёты и объявления приходят с одного эндпоинта в одинаковой форме. */

function normalizeReport(raw) {
  return {
    id: String(raw.id),
    name: raw.name ?? "",
    date: raw.date ?? "",
    href: toAbsoluteUrl(raw.file_url, "#"),
  };
}

function normalizeAnnouncement(raw) {
  return {
    id: String(raw.id),
    title: raw.title ?? "",
    date: raw.date ?? "",
    text: raw.text ?? "",
    files: (raw.files ?? []).map((file, index) => ({
      id: `${raw.id}-${index}`,
      name: file.name ?? "",
      href: toAbsoluteUrl(file.file_url, "#"),
    })),
  };
}

export function fetchReports({ limit = 50, page = 1, signal } = {}) {
  return apiGet("/reports", { params: { page, limit }, signal }).then((data) =>
    (data ?? []).map(normalizeReport),
  );
}

export function fetchAnnouncements({ limit = 50, page = 1, signal } = {}) {
  return apiGet("/announcements", { params: { page, limit }, signal }).then(
    (data) => (data ?? []).map(normalizeAnnouncement),
  );
}
